export default {
  related: 'Related articles',
  newsletterTitle: 'Get updates on the magic of 3D',
}
